export const getWindow = (): BaseWindow => {
    return window.r360 ? window.r360 : window;
};
